import React from 'react';
import ReactDOM from 'react-dom';
import { WeaLocaleProvider } from 'ecCom';
import { createHashHistory } from 'History';

import { Router, Route, useRouterHistory } from 'react-router';

import { syncHistoryWithStore, RouterStore } from 'mobx-react-router';

import { Provider } from 'mobx-react';

import Doc from 'weaDocDetail';
// import ComMobx from 'comsMobx';
const getLocaleLabel = WeaLocaleProvider.getLocaleLabel.bind(this, 'document');
const getLabel = WeaLocaleProvider.getLabel;
const routing = new RouterStore();

const allStore = {
  routing,
  ...Doc.store,
  // ...ComMobx.store,
};

const browserHistory = useRouterHistory(createHashHistory)({
  queryKey: '_key',
  basename: '/',
});

const history = syncHistoryWithStore(browserHistory, allStore.routing);

const Home = props => props.children;

const Root = () => (
  <Provider {...allStore}>
    <Router history={history}>
      <Route name='main' breadcrumbName={getLabel(126473,'入口')} path='/main' component={Home}>
        {Doc.Route}
      </Route>
    </Router>
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById('container'));
module.exports = Doc;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/documentDetail/single.js